import React from 'react';
import { Row, Col } from 'antd';

import { I18n } from '@aws-amplify/core';

import { IConclusion } from '../types';
import { Description } from './styles';
import { useNioshConclusion } from '@/hooks/useNioshConclusion';

interface HeaderProps {
	conclusion: IConclusion;
}

export const Header: React.FC<HeaderProps> = ({
	conclusion: { mass_m, lifting_index, recommended_weight_limit, risk }
}) => {
	const { text } = useNioshConclusion({ mass_m, lifting_index, recommended_weight_limit, risk });

	return (
		<Col span={24}>
			<Row>
				<Description>{text.map((conclusion_text) => I18n.get(conclusion_text))}</Description>
			</Row>
		</Col>
	);
};
